import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { get } from 'lodash';
import { mapStateToProps } from '../components/QueryFilterContainer';
import CohortFilterValue from './CohortFilterValue';
import { formatFilterValues } from '../helper';

const QueryFilterValuesCell = ({
  code,
  category,
  operator,
  type,
  values,
  join,
  dictionary,
  fieldConstraints,
  canRead,
  canEdit,
  width,
}) => {
  const intl = useIntl();
  const lookups = get(dictionary.lookups, `${fieldConstraints}.options`, []);
  const displayValue = formatFilterValues(type, operator, values, lookups, join, intl);
  return (
    <CohortFilterValue
      category={category}
      code={code}
      value={displayValue}
      canRead={canRead}
      canEdit={canEdit}
      title={displayValue}
      width={width}
    />
  );
};

export default connect(mapStateToProps)(QueryFilterValuesCell);
